import { SignupResponse } from '@porterin/booking-flow/src/auth/domain/api-models/SignupApiModel';
import { RESPONSE_MESSAGES } from '@porterin/booking-flow/src/auth/domain/config/responseMessages';
import { CustomerSignup } from '@porterin/booking-flow/src/auth/domain/entities/CustomerSignup';

const toSignupEntity = (_: SignupResponse): CustomerSignup => {
  return {
    message: RESPONSE_MESSAGES.RESPONSE_SIGNUP_SUCCESS,
  };
};

export { toSignupEntity };
